import { KnowledgePropositionPage } from './KnowledgePropositionPage';
export default KnowledgePropositionPage;